import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiPostSealedOrder } from '@/payment/api'

import { PAYMENT_KEYS } from '../keys'

/**
 * 밀봉 비닐 주문 신청 mutation.
 *
 * 성공 시 GET /orders 캐시 무효화 — 결제 완료 후 진입 분기에 반영.
 */
export const usePostSealedOrder = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: apiPostSealedOrder,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [PAYMENT_KEYS.ORDERS] })
    },
  })
}
